export enum ReportDomainType {
  TRAINING = "TRAINING",
  LEVEL_ASSESSMENT = "LEVEL_ASSESSMENT",
  CONTEST = "CONTEST",
  CUSTOM_ASSESSMENT = "CUSTOM_ASSESSMENT"
}